import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useNavigate, useLocation } from 'react-router-dom';
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material";
import { RingLoader } from 'react-spinners';
import { FormaDateBalanceSheet } from "../../../Common/FormatFunctions/FormatDate"

const apikey = process.env.REACT_APP_API;

const PurchaseRegister = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // const { fromDate, toDate } = location.state || { fromDate: '', toDate: '' ,companyCode : '',Year_Code : ''};
    const searchParams = new URLSearchParams(location.search);
    const Company_Name = sessionStorage.getItem('Company_Name')
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const company_Code = searchParams.get('companyCode');
    const YearCode = searchParams.get('yearCode');
    const acCode = searchParams.get('acCode');

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [grandTotals, setGrandTotals] = useState({
        TotalTaxable_Amt: 0,
        CGSTAmt: 0,
        SGSTAmt: 0,
        IGSTAmt: 0,
        BillamountAmt: 0,
        netqntl: 0
    });

    const API_URL = `${apikey}/Purchase_Register`;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                        Company_Code: company_Code,
                        Year_code: YearCode,
                        acCode: acCode
                    },
                });
                setReportData(response.data);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, [API_URL]);

    useEffect(() => {
        if (reportData.length > 0) {
            const totals = reportData.reduce(
                (acc, item) => {
                    acc.TotalTaxable_Amt += Number(item.subTotal) || 0;
                    acc.CGSTAmt += Number(item.CGSTAmount) || 0;
                    acc.SGSTAmt += Number(item.SGSTAmount) || 0;
                    acc.IGSTAmt += Number(item.IGSTAmount) || 0;
                    acc.BillamountAmt += Number(item.Bill_Amount) || 0;
                    acc.netqntl += Number(item.NETQNTL) || 0;
                    return acc;
                },
                { TotalTaxable_Amt: 0, CGSTAmt: 0, SGSTAmt: 0, IGSTAmt: 0, BillamountAmt: 0, netqntl: 0 }
            );

            setGrandTotals(totals);
        }
    }, [reportData]);

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();

        const headers = [
            "Our No", "Date", "Bill No", "Supplier Name", "Supplier GSTNo", "NetQntl", "GST Rate", "Taxable Amount", "CGST Amt", "SGST Amt", "IGST Amt", "Bill Amount"
        ];

        const formattedData = reportData.map(item => ({

            "Our No": item.doc_no,
            "Date": formatDate(item.doc_date),
            "Bill No": item.Bill_No,
            "Supplier Name": item.suppliername,
            "Supplier GSTNo": item.suppliergstno,
            "NetQntl": Number(item.NETQNTL) || 0,
            "GST Rate": item.gstrate,
            "Taxable Amount": Number(item.subTotal) || 0,
            "CGST Amt": Number(item.CGSTAmount) || 0,
            "SGST Amt": Number(item.SGSTAmount) || 0,
            "IGST Amt": Number(item.IGSTAmount) || 0,
            "Bill Amount": Number(item.Bill_Amount) || 0,

        }));

        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

        const wsCols = [
            { wch: 15 },
            { wch: 30 },
            { wch: 15, alignment: { horizontal: "right" } },
            { wch: 10, alignment: { horizontal: "right" } },
            { wch: 10, alignment: { horizontal: "right" } },
            { wch: 10, alignment: { horizontal: "right" } },
            { wch: 15, alignment: { horizontal: "right" } },
            { wch: 12, alignment: { horizontal: "right" } }
        ];
        ws["!cols"] = wsCols;

        XLSX.utils.book_append_sheet(wb, ws, 'PurchaseRegister');
        XLSX.writeFile(wb, 'PurchaseRegister.xlsx');
    };

    const handlePrint = async () => {
        const companyName = Company_Name;
        const fromDate = searchParams.get('fromDate');
        const toDate = searchParams.get('toDate');
        const pdfBlob = await generatePDF(companyName, fromDate, toDate);
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const win = window.open(pdfUrl, '',);
        win.document.close();
        win.print();
    };


    const generatePDF = async (companyName, fromDate, toDate) => {
        const doc = new jsPDF();

        const groupedData = groupReportData(reportData);
        const tableData = [];

        doc.setFontSize(16);
        doc.text(companyName, doc.internal.pageSize.width / 2, 10, { align: 'center' });

        doc.setFontSize(10);
        doc.text(`Sale Register From: ${formatDate(fromDate)} To ${formatDate(toDate)}`, 10, 20);

        tableData.push(["Our No", "Date", "Bill No", "Supplier Name", "Supplier GSTNo", "NetQntl", "GST Rate", "Taxable Amount", "CGST Amt", "SGST Amt", "IGST Amt", "Bill Amount"]);

        Object.entries(groupedData).forEach(([key, group]) => {
            group.items.forEach((item) => {
                tableData.push([
                    item.doc_no,
                    formatDate(item.doc_date),
                    item.Bill_No,
                    item.suppliername,
                    item.suppliergstno,
                    formatReadableAmount(item.NETQNTL),
                    item.gstrate,
                    formatReadableAmount(item.subTotal),
                    formatReadableAmount(item.CGSTAmount),
                    formatReadableAmount(item.SGSTAmount),
                    formatReadableAmount(item.IGSTAmount),
                    formatReadableAmount(item.Bill_Amount),
                ]);
            });
        });

        const totalRow = [
            '', '', '', 'Total', '',
            formatReadableAmount(grandTotals.netqntl),
            '',
            formatReadableAmount(grandTotals.TotalTaxable_Amt),
            formatReadableAmount(grandTotals.CGSTAmt),
            formatReadableAmount(grandTotals.SGSTAmt),
            formatReadableAmount(grandTotals.IGSTAmt),
            formatReadableAmount(grandTotals.BillamountAmt)
        ];

        tableData.push(totalRow);

        doc.autoTable({
            headStyles: {
                fillColor: [255, 0, 0],
                fontStyle: 'bold',
            },
            body: tableData,
            margin: { top: 25 },
            styles: {
                fontSize: 5,
                cellPadding: 1,
                halign: 'center',
            },
            columnStyles: {
                2: { halign: 'left' },
                4: { halign: 'right' },
                5: { halign: 'right' },
                6: { halign: 'right' },
                7: { halign: 'right' },
                8: { halign: 'right' },
                9: { halign: 'right' },
                10: { halign: 'right' },
            },
            theme: 'grid',
        });

        return doc.output('blob');
    };

    const groupReportData = (data) => {
        const groupedData = {};
        data.forEach((item) => {
            const key = `${item.purchaseid}`;
            if (!groupedData[key]) {
                groupedData[key] = {
                    items: [],
                    totalQty: 0,
                };
            }
            groupedData[key].items.push(item);
            groupedData[key].totalQty += parseFloat(item.Bill_Amount) || 0;
        });
        return groupedData;
    };

    const groupedReportData = groupReportData(reportData);
return (
    <div style={{marginTop:"-80px"}}>

    <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Purchase Register</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>

        <div className="mb-3 row align-items-center">
            <div className="col-auto">
                <button className="btn btn-secondary me-2" onClick={handlePrint}>Print</button>
                <button className="btn btn-success" onClick={handleExportToExcel}>Export to Excel</button>
            </div>
        </div>

        <TableContainer component={Paper} style={{ maxHeight: '80vh', overflow: 'auto' }} id="reportTable">
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {[
                            "Our No", "Date", "Bill No", "Supplier Name", "Supplier GST No",
                            "Net Quintal", "GST Rate", "Taxable Amount", "CGST Amount",
                            "SGST Amount", "IGST Amount", "Bill Amount"
                        ].map((label, i) => (
                            <TableCell
                                key={i}
                                sx={{
                                    position: 'sticky',
                                    top: 0,
                                    backgroundColor: '#f5f5f5',
                                    fontWeight: 'bold',
                                    zIndex: 2,
                                    textAlign: i < 3 ? 'center' : (i === 3 ? 'left' : 'right'),
                                    whiteSpace:"nowrap"
                                }}
                            >
                                {label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {Object.entries(groupedReportData).map(([key, { items }]) => (
                        <React.Fragment key={key}>
                            {items.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell align="center">{item.doc_no}</TableCell>
                                    <TableCell align="center">{formatDate(item.doc_date)}</TableCell>
                                    <TableCell align="center">{item.Bill_No}</TableCell>
                                    <TableCell align="left">{item.suppliername}</TableCell>
                                    <TableCell align="center">{item.suppliergstno}</TableCell>
                                    <TableCell align="right">{formatReadableAmount(item.NETQNTL)}</TableCell>
                                    <TableCell align="right">{item.gstrate}</TableCell>
                                    <TableCell align="right">{formatReadableAmount(item.subTotal)}</TableCell>
                                    <TableCell align="right">{formatReadableAmount(item.CGSTAmount)}</TableCell>
                                    <TableCell align="right">{formatReadableAmount(item.SGSTAmount)}</TableCell>
                                    <TableCell align="right">{formatReadableAmount(item.IGSTAmount)}</TableCell>
                                    <TableCell align="right">{formatReadableAmount(item.Bill_Amount)}</TableCell>
                                </TableRow>
                            ))}
                        </React.Fragment>
                    ))}

                    <TableRow>
                        <TableCell
                            colSpan={5}
                            sx={{
                                position: 'sticky',
                                bottom: 0,
                                backgroundColor: 'yellow',
                                fontWeight: 'bold',
                                zIndex: 1
                            }}
                        >
                          
                        </TableCell>
                        <TableCell
                            align="right"
                            sx={{
                                position: 'sticky',
                                bottom: 0,
                                backgroundColor: 'yellow',
                                fontWeight: 'bold',
                                zIndex: 1
                            }}
                        >
                            {formatReadableAmount(grandTotals?.netqntl || 0)}
                        </TableCell>
                        <TableCell
                            sx={{
                                position: 'sticky',
                                bottom: 0,
                                backgroundColor: 'yellow',
                                fontWeight: 'bold',
                                zIndex: 1
                            }}
                        >
                            
                        </TableCell>
                        {[grandTotals?.TotalTaxable_Amt, grandTotals?.CGSTAmt, grandTotals?.SGSTAmt, grandTotals?.IGSTAmt, grandTotals?.BillamountAmt].map((val, i) => (
                            <TableCell
                                key={i}
                                align="right"
                                sx={{
                                    position: 'sticky',
                                    bottom: 0,
                                    backgroundColor: 'yellow',
                                    fontWeight: 'bold',
                                    zIndex: 1
                                }}
                            >
                                {formatReadableAmount(val || 0)}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

        {loading && (
            <div style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 9999
            }}>
                <RingLoader size={80} />
            </div>
        )}

        {error && <div className="alert alert-danger">{error}</div>}
    </div>
);

};

export default PurchaseRegister;
